import Root from "./Root";
import Error from "./Error";
import {Route, Routes} from "react-router-dom";
import React from "react";
import MapView from "./MapView";
import Privacy from "./Privacy";
import Terms from "./Terms";
import DeleteAccount from "./DeleteAccount";
import Forum from "./Forum";
import ForumThread from "./ForumThread";

const RootNavigation = () => {
    return (
            <Routes>
                <Route path="/"
                       element={<Root/>}
                       errorElement={<Error/>}
                >
                    <Route index element={<MapView />}/>
                </Route>
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/delete-account" element={<DeleteAccount />} />
                <Route path="/forum" element={<Forum />} />
                <Route path="/forum/:threadId" element={<ForumThread />} />
            </Routes>);
};

export default RootNavigation;
